import React from 'react';
import { Box, Grid, useTheme } from '@mui/material';
import { DocumentName } from '@/components/document/Name';
import { DocumentPreview, TextChunks } from '@/components/document';
import { Notification } from '@/components/Notification';
import { Button } from '@/components/Button';
import { ArrowBack, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDocuments } from '@my-helpers/common';
import { Tags } from '@/components/Tags';

interface DocumentViewProps {
    documentId: string;
}

const DocumentView: React.FC<DocumentViewProps> = ({ documentId }) => {
    const { view, command } = useDocuments();
    const { isLoading, error, currentDocument } = view;
    const { getContent, clearError } = command;
    const theme = useTheme();
    const navigate = useNavigate();

    if (!currentDocument) {
        return (
            <Box
                padding={theme.spacing(3)}
                flexDirection="column"
                flexGrow={1}
                minHeight={0}
                display="flex">
                <Notification
                    isLoading={isLoading}
                    error={error}
                    clearError={clearError}
                />
            </Box>
        )
    }

    return (
        <Box padding={theme.spacing(3)}
            flexDirection="column"
            flexGrow={1}
            minHeight={0}
            display="flex"
        >
            <Box display="flex"
                alignItems="center"
                gap={2}
                mb={3}
            >
                <DocumentName
                    name={currentDocument.file_name}
                    handleInputChange={() => { }} />
                <Box display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                    gap={1}
                    padding={theme.spacing(0, 0, 0, 2)}
                >
                    <Button variant="secondary"
                        icon={<ArrowBack />}
                        tooltip="Back to documents"
                        onClick={() => navigate(-1)}
                    />
                    <Button variant="secondary"
                        icon={<Delete />}
                        tooltip="Delete document"
                        onClick={() => navigate(-1)}
                    />
                </Box>
            </Box>
            <Grid container
                spacing={2}
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden'
                }}>
                <Grid size={8}
                    sx={{
                        height: '100%',
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                    <TextChunks
                        textChunks={currentDocument.text_chunks}
                    />
                </Grid>
                <Grid size={4}
                    sx={{
                        height: '100%',
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                    <Box 
                        flexShrink={0} 
                        padding={theme.spacing(1, 0, 0, 0)}>
                        <Tags
                            tags={currentDocument.tagged_by || []}
                            handleInputChange={() => { }}
                        />
                    </Box>
                    <DocumentPreview
                        key={currentDocument.id}
                        currentDocument={currentDocument}
                        getContent={getContent}
                    />
                </Grid>
            </Grid>
            <Notification
                isLoading={isLoading}
                error={error}
                clearError={clearError}
            />
        </Box>
    )
};

export default DocumentView;